module.exports = __webpack_public_path__ + "static/img/3.f438e623.png";